import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { connect } from "react-redux";
import Pagination from "./variationPagination";
import { fetchVariationListForGroup } from "./../../../components/UserFunctions";
import { scenarioVariationListData } from "../../../actions/closeLoop/scenarioGroup/expandableScenarioComponentAction";

function expandableScenarioComponent(props) {
    // const [scenarioInfo, setScenarioInfo] = useState([]);
    console.log("expandable data", props.scenarioId);
    const scenarioId = props.scenarioId;

    useEffect(() => {
        fetchVariationListForGroup(scenarioId).then((response) => {
            if (response.data) {
                console.log("variation response", response);
                // setScenarioInfo(response.data);
                props.scenarioVariationList(response);
            } else {
                props.scenarioVariationList({ data: [], current_page: 0, pages: [] });
            }
        });
        // console.log("var list",props.variationListInfo)
        // setScenarioInfo(props.variationListInfo)
    }, []);
    console.log("var list", props.variationListInfo);

    const customExpandableStyles = {
        rows: {
            style: {
                minHeight: "72px",
            },
        },
        headCells: {
            style: {
                fontSize: "1rem",
                backgroundColor: "white",
                padding: ".75rem",
                verticalAlign: "top",
                borderTop: "1px solid #e9ecef",
                borderBottom: "3px solid #757AF7",
                justifyContent: "center",
            },
        },
        cells: {
            style: {
                // fontSize: "1rem",
                textAlign: "center",
                verticalAlign: "top",
                borderTop: "5px solid white",
                justifyContent: "center",
            },
        },
    };

    const scn_columns = [
        {
            name: "Scenario Name",
            selector: "scenario_name",
            sortable: true,
            cell: (row) => <div>{row.scenario_name}</div>,
        },
        {
            name: "Scenario Description",
            selector: "scenario_description",
            sortable: true,
            cell: (row) => <div style={{ alignContent: "center" }}>{row.scenario_description}</div>,
            grow: 3,
        },
        {
            name: "Scenario UUID",
            selector: "scenario_uuid",
            sortable: true,
            cell: (row) => <div style={{ alignContent: "center" }}>{row.scenario_uuid}</div>,
        },
        {
            name: "Scenario ID",
            selector: "scenario_id",
            sortable: true,
            cell: (row) => <div style={{ alignContent: "center" }}>{row.scenario_id}</div>,
        },
        {
            name: "Group ID",
            selector: "scenario_group_id",
            sortable: true,
            cell: (row) => <div style={{ alignContent: "center" }}>{row.scenario_group_id}</div>,
        },
    ];

    return (
        <div>
            <DataTable
                data={props.variationListInfo}
                // data={scenarioInfo}
                columns={scn_columns}
                customStyles={customExpandableStyles}
            />
            {/* {this.state.paginationError ? (
                    <Alert key="danger" variant="danger">
                        {this.state.paginationError}
                    </Alert>
                ) : undefined}*/}
            {/* {Object.keys(scenarioInfo).length > 0 ? ( */}
            {Object.keys(props.variationListInfo).length > 0 ? (
                <Pagination
                    currentPage={props.currentPage}
                    pages={props.pages}
                    getApiInfo={fetchVariationListForGroup}
                    action={scenarioVariationListData}
                    scenarioId={scenarioId}
                />
            ) : undefined}
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        variationListInfo: state.scenarioVariationInfo.scenarioVariationData,
        currentPage: state.scenarioVariationInfo.currentPage,
        pages: state.scenarioVariationInfo.pages,
    };
};

const mapDispatchToProps = (dispatch) => ({
    scenarioVariationList: (scenarioVariationData) =>
        dispatch(scenarioVariationListData(scenarioVariationData)),
});

export default connect(mapStateToProps, mapDispatchToProps)(expandableScenarioComponent);
